import { useQuery } from '@tanstack/react-query';
import { Workflow } from 'pages/AgenticWorkflow/AgenticWorkflow.types';
import { getAgenticWorkflows } from 'services/api/getAgenticWorkflows';
import { queryKeys } from '../queryKeys';

const sortWorkflowsByCreatedAt = (workflows: Workflow[]): Workflow[] =>
    [...workflows].sort((a, b) => new Date(b.created_at || '').getTime() - new Date(a.created_at || '').getTime());

export const useGetAgenticWorkflows = () => {
    const { data, isLoading, isFetching, refetch, ...rest } = useQuery({
        queryKey: queryKeys.agenticWorkflows,
        queryFn: getAgenticWorkflows,
        select: (workflows) => sortWorkflowsByCreatedAt(workflows ?? []),
    });

    return {
        agenticWorkflows: data ?? [],
        isLoadingAgenticWorkflows: isLoading || isFetching,
        refetchAgenticWorkflows: refetch,
        ...rest,
    };
};
